import ScrollMagic from 'scrollmagic';
import Controller from '@/scripts/utils/scrollmagic/controller';
import selectors from '@/scripts/animation/animation-selectors';
import { TweenMax } from 'gsap/TweenMax';
import './parallax-item.scss';

document.addEventListener('DOMContentLoaded', () => {
  const containers = document.querySelectorAll(selectors.parallaxDefaultContainer);
  containers.forEach((container) => {
    const { parallaxDistance, parallaxItem } = selectors;
    const item = container.querySelector(parallaxItem);
    item.classList.add('parallax-item');
    const direction = container.dataset.direction || 'Y';

    let scrollProgress = 0;
    const itemTransform = {
      translate: 0,
    };

    TweenMax.ticker.addEventListener('tick', () => {
      if (scrollProgress > 0 && scrollProgress < 1) {
        itemTransform.translate += (scrollProgress * parallaxDistance - itemTransform.translate) * 0.05;
        itemTransform.translate = (Math.abs(itemTransform.translate - scrollProgress * parallaxDistance)) < 0.5
          ? scrollProgress * parallaxDistance
          : itemTransform.translate;
        $(item).css({
          transform: `translate${[direction]}(${itemTransform.translate}px)`,
        });
      }
    });


    return new ScrollMagic.Scene({
      triggerElement: container,
      triggerHook: 'onEnter',
      offset: -80,
      duration: $(item).height() + $(window).height(),
    })
      .on('progress', (e) => {
        scrollProgress = e.progress;
      })
      .addTo(Controller);
  });
});



// WEBPACK FOOTER //
// ./scripts/utils/scrollmagic/scenes/parallax-item/parallax-item.js